import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"books, library"} maskId="square-filled-radius-0-stroke-1-IconBooks"><path fillRule="evenodd" clipRule="evenodd" d="M14 6.67175L18.8063 5.29357L22.9409 19.7125L18.1346 21.0907L14 6.67175Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M8 3V21H14V3H8ZM9 7H13V8H9V7ZM13 16H9V17H13V16Z" fill="currentColor"/><path d="M2 5V21H7V5H2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBooks;
